// External libraries
import React from 'react';
import { func } from 'prop-types';
import { useStoreState } from 'easy-peasy';
import { FloatingLabelInput } from '@checkout/react-components';

// Internal modules
import { getContent } from '@/lib';
import { useMountLogging } from '@/lib/reactHooks';
import { validationFunctionMap } from './validation';

const SecondaryIdentityDocumentNumber = props => {
  useMountLogging('SecondaryIdentityDocumentNumber');
  const secondaryIdentityDocumentNumber = useStoreState(
    ({ form }) => form.secondaryIdentityDocumentNumber,
  );
  const secondaryIdentityDocumentType = useStoreState(
    ({ form }) => form.secondaryIdentityDocumentType.value,
  );

  return (
    <FloatingLabelInput
      blurHandler={props.blurHandler}
      changeHandler={props.changeHandler}
      focusHandler={props.focusHandler}
      id="secondaryIdentityDocumentNumber"
      label={getContent('fieldLabels.secondaryIdentityDocumentNumber')}
      required={true}
      validationFn={validationFunctionMap[secondaryIdentityDocumentType]}
      {...secondaryIdentityDocumentNumber}
    />
  );
};

SecondaryIdentityDocumentNumber.propTypes = {
  blurHandler: func,
  changeHandler: func.isRequired,
  focusHandler: func,
};

export { SecondaryIdentityDocumentNumber };
